document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.sticky_break') && document.querySelector('.sticky_bar')) {
        const element = document.querySelector('.sticky_break'); // Element, jehož výšku chcete zjistit
        const stickyelement = document.querySelector('.sticky_bar');


        let lastScroll = 0;
        const scrooloffset = 50;
        window.addEventListener('scroll', () => {
            const scrollposition = window.pageYOffset;
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
            //console.log(lastScroll + '/' + scrollposition);
            if (Math.abs(lastScroll - scrollposition) > scrooloffset) {
                if (isVisible) {
                    stickyelement.classList.remove('show_sticky_bar');
                } else {

                    stickyelement.classList.add('show_sticky_bar');

                }
                lastScroll = scrollposition;
            }

        });
    }
});

const arrowup = document.getElementById("arrow-up-holder");


function scrollFunction() {

    const scrollposition = window.pageYOffset;

    if (scrollposition > 150 + (document.querySelector('.mainpage-banner') ? 500 : 0)) {
        arrowup.classList.add("showarrow");
    } else {
        arrowup.classList.remove("showarrow");
    }
}

// Přidání posluchače pro scroll
window.addEventListener("scroll", scrollFunction);

jQuery('.short-description-link').on('click', function () {
    document.getElementById('woocommerce-tabs-dji').scrollIntoView({ behavior: 'smooth' });
});